import { Layout } from '@/views/platform';

export default {
    path: '/platform',
    component: Layout,
    children: [
        { path: 'add', component: () => import('@/views/platform/AddPlatform.vue') },
    ]
};
